<div class="efx-row-datasource mx-0 source_item">
  <div class="item_title">
    <b style="font-size: 24px;">{{data.message}}</b>
  </div>
  <div class="wrapper_data">
    <div class="item_values">
      @if (bofuenteSeleccionada) {
        <div class="item_value">
          <span class="title">Período desde</span>
          <span class="value">
            <p class="efx-row-input-data">
              <input [(ngModel)]="periodoini" placeholder="YYYYMM" maxlength="6" (keypress)="numberOnly($event)" class="form-control efx-input" type="text"/>
            </p>
          </span>
        </div>
      }
      @if (bofuenteSeleccionada) {
        <div class="item_value">
          <span class="title">Período hasta</span>
          <span class="value">
            <p class="efx-row-input-data">
              <input [(ngModel)]="periodofin" placeholder="YYYYMM" maxlength="6" (keypress)="numberOnly($event)" class="form-control efx-input" type="text"/>
            </p>
          </span>
        </div>
      }
      @if (bofuenteSeleccionada) {
        <div class="item_value">
          <span class="title">Motivo</span>
          <span class="value">
            <p><b>NOC: MODIFICACIÓN</b></p>
          </span>
        </div>
      }
      @if (bofuenteSeleccionada) {
        <div class="item_value">
          <span class="title">Comentarios</span>
          <span class="value">
            <p class="efx-row-input-data">
              <input [(ngModel)]="comentarios" class="form-control efx-input" type="text"/>
            </p>
          </span>
        </div>
      }
      <div class="item_value">
        <span class="title">Lista de Situaciones</span>
        <span class="value">
          <select style="width: 620px;" class="efx-select" [(ngModel)]="values" (ngModelChange)="addValue($event)">
            <option value="">Seleccione una situación</option>
            @for (acuList of data.list; track acuList) {
              <option [value]="acuList.code" selected="">
                {{ acuList.code + ': ' + acuList.description }}
              </option>
            }
          </select>
        </span>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <button class="efx-button-secondary button-secondary" (click)="onNoClick()">{{data.onCancelText === undefined ? 'Cancelar' : data.onSubmitText}}</button>&nbsp;
    <button class="efx-button-primary button-primary" (click)="onSubmit()" cdkFocusInitial
    [disabled]="btnStatus">{{data.onSubmitText === undefined ? 'Guardar' : data.onSubmitText}}</button>
  </div>
</div>
